import { useState } from "react";
import Search from "antd/es/transfer/search";
import { Button, Select, DatePicker, Space } from "antd";
import { Link } from "react-router-dom";
import useResponsive from "../hooks/useResponsive";

const Filter = ({
  filterOptions = {},
  setFilterOptions,
  addItemName = "",
  addItemUrl = "",
  addItemAction,
  searchBarPlaceholder = "",
  dropdowns = [],
  filterBy = true,
  resetFilter = true,
  onFilterChange,
}) => {
  const { isResponsiveMode, isMobile, isTablet } = useResponsive();

  // Handle dropdown and search filter changes
  const handleFilterChange = (key, value) => {
    setFilterOptions((prevOptions) => {
      const updatedOptions = {
        ...prevOptions,
        [key]: value !== "" ? value : undefined,
      };

      // Trigger external filter change if applicable
      if (onFilterChange) {
        onFilterChange(key, value);
      }

      return updatedOptions;
    });
  };

  // Handle DatePicker Change
  const handleDateChange = (date, dateString) => {
    handleFilterChange("Date", dateString);
  };

  // Reset filters
  const handleResetFilter = () => {
    setFilterOptions({});
    if (onFilterChange) {
      onFilterChange("", "");
    }
  };

  return (
    <div className={`w-full flex flex-col ${!isMobile ? "md:flex-row" : ""} gap-4 p-2 md:p-4`}>
      {(filterBy || dropdowns.length > 0 || resetFilter) && (
        <div className={`flex flex-col ${!isMobile ? "md:flex-row" : ""} items-start md:items-center gap-3 md:gap-4 ${isMobile ? "w-full" : ""}`}>
          {filterBy && (
            <div className="text-nowrap">
              <span style={{ fontWeight: "700" }}>Filter By</span>
            </div>
          )}

          {/* Dropdown Filters */}
          {dropdowns.length > 0 && (
            <div className={`flex flex-wrap gap-3 ${isMobile ? "w-full" : ""}`}>
              {dropdowns.map((dropdown) => (
                <div
                  key={dropdown.title}
                  className={`flex ${isMobile ? "flex-col" : "items-center"} gap-2 ${isMobile ? "w-full" : "min-w-[180px]"}`}
                >
                  <label className="whitespace-nowrap">{dropdown.title}</label>
                  {dropdown.type === "date" ? (
                    <DatePicker
                      className="w-full"
                      onChange={handleDateChange}
                      size={isMobile ? "middle" : "default"}
                    />
                  ) : (
                    <Select
                      style={{ width: isMobile ? "100%" : "150px" }}
                      value={filterOptions[dropdown.title] || undefined}
                      onChange={(value) =>
                        handleFilterChange(dropdown.title, value)
                      }
                      placeholder={dropdown.title}
                      showSearch
                      size={isMobile ? "middle" : "default"}
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {dropdown.options?.map((option, index) => (
                        <Select.Option key={index} value={option}>
                          {option}
                        </Select.Option>
                      ))}
                    </Select>
                  )}
                </div>
              ))}
            </div>
          )}

          {/* Reset Filter */}
          {resetFilter && (
            <div className="text-nowrap mt-1 md:mt-0">
              <button
                className="flex items-center text-[#FF0000] gap-1"
                onClick={handleResetFilter}
              >
                Reset Filter <img src="/assets/images/Path.svg" alt="Reset" />
              </button>
            </div>
          )}
        </div>
      )}

      <div className={`flex ${isMobile ? "flex-col" : "flex-row"} items-center gap-3 md:gap-4 flex-1`}>
        {/* Search Bar */}
        <div className="flex-1 w-full min-w-[150px] height-search">
          <Search
            placeholder={searchBarPlaceholder}
            allowClear
            onSearch={(value) => handleFilterChange("search", value)}
            value={filterOptions.search || ""}
            onChange={(e) => handleFilterChange("search", e.target.value)}
            size={isMobile ? "middle" : "default"}
          />
        </div>

        {/* Add Item Button */}
        {addItemName && (
          <div className={`${isMobile ? "w-full mt-2" : ""}`}>
            {addItemUrl && (
              <Link to={addItemUrl} className={isMobile ? "w-full block" : ""}>
                <Button
                  style={{
                    backgroundColor: "#3371EB",
                    color: "white",
                    fontSize: isMobile ? 14 : 16,
                    padding: isMobile ? "12px 16px" : "20px 16px",
                    width: isMobile ? "100%" : "auto",
                  }}
                >
                  + {addItemName}
                </Button>
              </Link>
            )}
            {addItemAction && (
              <Button
                onClick={addItemAction}
                style={{
                  backgroundColor: "#3371EB",
                  color: "white",
                  fontSize: isMobile ? 14 : 16,
                  padding: isMobile ? "12px 16px" : "20px 16px",
                  width: isMobile ? "100%" : "auto",
                }}
              >
                + {addItemName}
              </Button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Filter;
